"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unsubscribeUser = exports.subscribeUser = exports.saveFeaturedTopics = exports.removeMember = exports.leaveGroup = exports.joinGroup = exports.generateInviteToken = exports.fetchUsers = exports.fetchMembersFilters = exports.fetchMembers = exports.declineApplication = exports.checkUserSubscribed = exports.approveApplication = exports.addMembers = exports.STATUS_USER_UNSUBSCRIBED = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var fetchMembersFilters;
exports.fetchMembersFilters = fetchMembersFilters;

(function (fetchMembersFilters) {
  fetchMembersFilters["Applicants"] = "applicants";
  fetchMembersFilters["Moderators"] = "moderators";
})(fetchMembersFilters || (exports.fetchMembersFilters = fetchMembersFilters = {}));

var fetchMembers = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(options) {
    var query, search, filter, response;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            query = "page=".concat(options.page, "&size=").concat(options.pageSize);
            search = options.searchString ? "&search=".concat(options.searchString) : '';
            filter = options.filter ? "&filter=".concat(options.filter) : '';
            _context.next = 5;
            return _axios.default.get("/groups/".concat(options.groupId, "/members?").concat(query).concat(search).concat(filter));

          case 5:
            response = _context.sent;
            return _context.abrupt("return", {
              members: response.data.members,
              total: response.data.total
            });

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchMembers(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.fetchMembers = fetchMembers;

var fetchUsers = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(url, responseKey) {
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", _axios.default.get(url).then(function (response) {
              return responseKey ? response.data[responseKey] : response.data;
            }));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchUsers(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

exports.fetchUsers = fetchUsers;

var generateInviteToken = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(payload) {
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", _axios.default.post("/groups/".concat(payload.groupId, "/generate-invite-token"), {
              expiryInDays: payload.expiry
            }).then(function (response) {
              return response.data.token;
            }));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function generateInviteToken(_x4) {
    return _ref3.apply(this, arguments);
  };
}();

exports.generateInviteToken = generateInviteToken;

var addMembers = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(payload) {
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _axios.default.post("/groups/".concat(payload.groupId, "/moderation/addMembers"), payload.data);

          case 2:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function addMembers(_x5) {
    return _ref4.apply(this, arguments);
  };
}();

exports.addMembers = addMembers;

var removeMember = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(payload) {
    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _axios.default.post("/groups/".concat(payload.groupId, "/moderation/removeMembers"), payload.data);

          case 2:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function removeMember(_x6) {
    return _ref5.apply(this, arguments);
  };
}();

exports.removeMember = removeMember;

var saveFeaturedTopics = /*#__PURE__*/function () {
  var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(payload) {
    return _regenerator.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return _axios.default.post("/groups/".concat(payload.groupId, "/featured-topics"), payload.data);

          case 2:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function saveFeaturedTopics(_x7) {
    return _ref6.apply(this, arguments);
  };
}();

exports.saveFeaturedTopics = saveFeaturedTopics;

var declineApplication = /*#__PURE__*/function () {
  var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(payload) {
    return _regenerator.default.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return _axios.default.post("/groups/".concat(payload.groupId, "/moderation/declineApplication/").concat(payload.userId));

          case 2:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function declineApplication(_x8) {
    return _ref7.apply(this, arguments);
  };
}();

exports.declineApplication = declineApplication;

var approveApplication = /*#__PURE__*/function () {
  var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(payload) {
    return _regenerator.default.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return _axios.default.post("/groups/".concat(payload.groupId, "/moderation/approveApplication/").concat(payload.userId));

          case 2:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function approveApplication(_x9) {
    return _ref8.apply(this, arguments);
  };
}();

exports.approveApplication = approveApplication;
var STATUS_USER_UNSUBSCRIBED = 404;
exports.STATUS_USER_UNSUBSCRIBED = STATUS_USER_UNSUBSCRIBED;

var checkUserSubscribed = /*#__PURE__*/function () {
  var _ref9 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9(groupId) {
    return _regenerator.default.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return _axios.default.get("/subscribers/group/".concat(groupId));

          case 2:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function checkUserSubscribed(_x10) {
    return _ref9.apply(this, arguments);
  };
}();

exports.checkUserSubscribed = checkUserSubscribed;

var unsubscribeUser = /*#__PURE__*/function () {
  var _ref10 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10(payload) {
    return _regenerator.default.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return _axios.default.delete("/subscribers/group/".concat(payload.groupId), {
              data: {
                csrfToken: payload.csrfToken
              }
            });

          case 2:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));

  return function unsubscribeUser(_x11) {
    return _ref10.apply(this, arguments);
  };
}();

exports.unsubscribeUser = unsubscribeUser;

var subscribeUser = /*#__PURE__*/function () {
  var _ref11 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11(payload) {
    return _regenerator.default.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 2;
            return _axios.default.post("/subscribers/group/".concat(payload.groupId), {
              csrfToken: payload.csrfToken
            });

          case 2:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));

  return function subscribeUser(_x12) {
    return _ref11.apply(this, arguments);
  };
}();

exports.subscribeUser = subscribeUser;

var leaveGroup = /*#__PURE__*/function () {
  var _ref12 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee12(payload) {
    return _regenerator.default.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return _axios.default.post("/group/".concat(payload.groupId, "/leave"), {
              csrfToken: payload.csrfToken
            });

          case 2:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));

  return function leaveGroup(_x13) {
    return _ref12.apply(this, arguments);
  };
}();

exports.leaveGroup = leaveGroup;

var joinGroup = /*#__PURE__*/function () {
  var _ref13 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee13(payload) {
    return _regenerator.default.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.next = 2;
            return _axios.default.post("/group/".concat(payload.groupId, "/join"), {
              csrfToken: payload.csrfToken
            });

          case 2:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));

  return function joinGroup(_x14) {
    return _ref13.apply(this, arguments);
  };
}();

exports.joinGroup = joinGroup;